import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

const TESTIMONIALS = [
  {
    id: 'test-001',
    quote:
      "Kasnimo helped me organize 8 scholarship applications at once. I got the Chevening — I couldn't have done it without the deadline tracking.",
    name: 'Priya Nair',
    title: 'Chevening Scholar 2025, India',
    avatar: 'PN',
  },
  {
    id: 'test-002',
    quote:
      "The document vault saved me so much time. Upload once, use across all applications. The match scores pointed me to scholarships I'd never found myself.",
    name: 'Kofi Asante',
    title: 'DAAD Scholar 2025, Ghana',
    avatar: 'KA',
  },
];

const STATS = [
  { id: 'stat-scholars', value: '12,400+', label: 'Students Organized' },
  { id: 'stat-scholarships', value: '3,200+', label: 'Scholarships Tracked' },
  { id: 'stat-accepted', value: '68%', label: 'Acceptance Rate' },
];

export default function AuthBrandPanel() {
  return (
    <div className="w-full gradient-brand flex flex-col justify-between p-10 xl:p-14 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 right-10 w-64 h-64 rounded-full bg-white" />
        <div className="absolute bottom-20 left-10 w-48 h-48 rounded-full bg-white" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full bg-white opacity-5" />
      </div>
      <div className="relative">
        {/* Logo */}
        <div className="flex items-center gap-3 mb-12">
          <AppLogo size={36} />
          <span className="font-bold text-white text-xl tracking-tight">Kasnimo</span>
        </div>

        {/* Headline */}
        <div className="mb-10">
          <h1 className="text-display font-bold text-white leading-tight mb-4">
            Your scholarship journey, <span className="text-blue-200">organized.</span>
          </h1>
          <p className="text-blue-100 text-base leading-relaxed max-w-sm">
            Discover international scholarships, track deadlines, prepare documents, and manage
            every application from one workspace.
          </p>
        </div>

        {/* Feature highlights */}
        <div className="space-y-3 mb-10">
          {[
            {
              id: 'feat-discover',
              icon: '🔍',
              text: 'Discover 3,200+ verified scholarships worldwide',
            },
            {
              id: 'feat-match',
              icon: '⭐',
              text: 'Instant eligibility matching against your profile',
            },
            { id: 'feat-track', icon: '📋', text: 'Auto-generated checklists per scholarship' },
            { id: 'feat-deadline', icon: '⏰', text: 'Never miss a deadline with smart reminders' },
          ]?.map((feat) => (
            <div key={feat?.id} className="flex items-center gap-3">
              <span className="text-lg">{feat?.icon}</span>
              <p className="text-sm text-blue-100">{feat?.text}</p>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 mb-10">
          {STATS?.map((stat) => (
            <div key={stat?.id} className="text-center bg-white/10 rounded-2xl py-3 px-2">
              <p className="text-xl font-bold text-white tabular-nums">{stat?.value}</p>
              <p className="text-2xs text-blue-200 mt-0.5">{stat?.label}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Testimonial */}
      <div className="relative">
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/20">
          <svg viewBox="0 0 24 24" className="w-6 h-6 text-blue-200 fill-current mb-3 opacity-60">
            <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z" />
            <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z" />
          </svg>
          <p className="text-sm text-white leading-relaxed mb-4">{TESTIMONIALS?.[0]?.quote}</p>
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center">
              <span className="text-xs font-bold text-white">{TESTIMONIALS?.[0]?.avatar}</span>
            </div>
            <div>
              <p className="text-sm font-semibold text-white">{TESTIMONIALS?.[0]?.name}</p>
              <p className="text-2xs text-blue-200">{TESTIMONIALS?.[0]?.title}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
